export const paramsWarningNotify = {
  title: 'Aviso',
  dismissible: true,
  dismissAfter: 3000
}



// WEBPACK FOOTER //
// ./src/utils/notifyConfig.js